interface QueryResultLike<T> {
  data?: T;
  error?: unknown;
}

export function requireQueryData<T>({
  data,
  error,
}: Readonly<QueryResultLike<T>>): T {
  if (error || !data) {
    throw error ?? new Error('Query returned no data');
  }
  return data;
}
